import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'policy',
  templateUrl: './policy.component.html',
  styleUrls: [ './policy.component.scss' ]
})
export class PolicyComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
